import { object, string } from "yup";

export default object().shape({
  email: string().required("Ce champs est obligatoire."),
  password: string().required("Ce champs est obligatoire."),
});
